import { Component, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TabOptions } from 'src/app/_models/tab-options';

@Component({
  selector: 'app-underlined-option-tab-toggle',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './underlined-option-tab-toggle.component.html',
  styleUrl: './underlined-option-tab-toggle.component.scss',
})
export class UnderlinedOptionTabToggleComponent {
  title: 'OptionTabToggle';
  component: '';

  /** Radio group name (required) */
  radioGroup = input<string>();

  /** What value and text for each button (required) */
  selectOptions = input<TabOptions[]>([]);
}
